import React from "react";
import { createPortal } from "react-dom";
import { FaMicrophoneSlash, FaVideoSlash, FaTimes } from "react-icons/fa";
import usePointerDrag from "./usePointerDrag";
import { StreamVideo } from "./StreamMedia";
import "./meeting.css";

export default function FloatingCallOverlay({
  visible,
  data,
  onOpen,
  onClose,
}) {
  const drag = usePointerDrag({ floating: true, visible, onActivate: onOpen });
  if (!visible || !data || typeof document === "undefined") return null;
  return createPortal(
    <div
      ref={drag.ref}
      {...drag.handlers}
      className="ant-call-floating"
      style={drag.style}
    >
      {data.isCameraOn && data.stream ? (
        <StreamVideo stream={data.stream} contain={data.isScreenShare} />
      ) : (
        <div className="ant-call-camera-off">
          <FaVideoSlash />
          <span>Camera off</span>
        </div>
      )}
      <button
        type="button"
        className="ant-call-floating-open"
        aria-label="Return to fullscreen call"
        onClick={(event) => {
          if (event.detail === 0) onOpen();
        }}
      />
      <button
        type="button"
        data-no-drag
        className="ant-call-floating-close"
        aria-label="Hide call preview"
        onPointerDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      >
        <FaTimes />
      </button>
      {data.isMuted && (
        <span className="ant-call-mic-badge">
          <FaMicrophoneSlash />
        </span>
      )}
      <span className="ant-call-name">{data.userName}</span>
    </div>,
    document.body,
  );
}
